<template>
  <div>
    <div v-if="pageId !== null && productId !== null">


      <div class="flex  items-center ">

        <input class="w-9/12 h-6 " type="text" placeholder="Suchbegriff..." v-model="searchTerm"
               v-on:keyup.enter="search" data-ui="input-image-search">
        <div @click="clearSearch"
             class="w-1/12 mr-1 h-6 bg-white   flex justify-center items-center hover:bg-active hover:text-white cursor-pointer"
             data-ui="button-clear-search">
          <i class="fa-solid fa-circle-xmark"></i>
        </div>
        <div @click="getTemplates"
             class="w-1/12 mr-1 h-6 bg-white flex justify-center items-center hover:bg-active hover:text-white cursor-pointer"
             data-ui="button-search-image">
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
        <div @click="prevPage" class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer">
          <i class="fa-solid fa-arrow-left "></i>
        </div>
        <div @click="nextPage" class="bg-white px-2 py-1 hover:bg-active hover:text-white cursor-pointer">
          <i class="fa-solid fa-arrow-right"></i>
        </div>
      </div>
      <div class="flex mb-2 mt-2 w-full">
        <div class="w-2/6 flex ">
          <button class="p-1 w-1/2  hover:bg-active hover:text-white cursor-pointer " @click="toggle('fitting')"
                  data-ui="button-select-search-logo"
                  :class="{ 'bg-active text-white': selectedOptionTemplate === 'fitting',  'bg-white': selectedOptionTemplate !== 'fitting' }">
            Passend
          </button>
          <button class="p-1 w-1/2 hover:bg-active hover:text-white cursor-pointer" @click="toggle('all')"
                  data-ui="button-select-search-picture"
                  :class="{ 'bg-active text-white': selectedOptionTemplate === 'all', 'bg-white': selectedOptionTemplate !== 'all' }">
            Alle
          </button>

        </div>
        <select class="w-4/6 ml-1"
                v-model="templateGroupId" @change="getTemplates">
          <option :value="0">Alle</option>
          <option v-for="articleTemplateGroup in articleTemplateGroups"
                  :key="articleTemplateGroup.idArticleTemplateGroup"
                  :value="articleTemplateGroup.idArticleTemplateGroup">{{ articleTemplateGroup.name }}
          </option>
        </select>
      </div>
      <div v-if="searchResult?.length > 0 && pageCount > 0" class="flex mb-2">
        Seiten {{ page + 1 }} von {{ pageCount }}
      </div>


      <div class="grid grid-cols-3 gap-2" data-ui="article-template-elements">
        <div v-for="template in templates" class="flex flex-col  flex-grow bg-white  border-2"
        :class="{'border-trader-dark-gray': template.templateId != productTemplateId, 'border-trader-blue' : template.templateId == productTemplateId}">
          <div class="flex flex-col justify-center items-center flex-2 h-[120px]"
               @mouseover="mouseEnter(template)"
               @mouseleave="mouseLeave">

            <div class="object-contain relative overflow-hidden">
              <object type="image/svg+xml" class="w-full h-full"
                      :data="'/api/v3/preview/page/'+ pageId + '/product/' + productId + '/template/' + template.templateId">
                <param name="type" value="image/svg+xml">
              </object>
            </div>


            <div class="flex items-center justify-between  w-full"
                 :class="{'text-black bg-inactive': template.templateId != productTemplateId, 'text-white bg-trader-blue' : template.templateId == productTemplateId}">

              <div class="w-1/3 px-1 leading-6 h-full hover:bg-trader-blue hover:text-white text-center cursor-pointer" data-ui="show-template-preview"
                   @click="showModal(template.templateId)">
                  <i class="fa-solid fa-magnifying-glass pr-1"></i>
              </div>

              <div class="w-1/3 px-1 leading-6 h-full hover:bg-trader-blue hover:text-white text-center cursor-pointer" data-ui="assign-template-on-page"
                   @click="() => { onAssignTemplate(template); }" title="Abbildung oder Logo dem Artikel zuweisen">
                <i class="fa-solid fa-link hover:bg-trader-blue "></i>
              </div>

              <div v-if="userData.isAdmin"
                   @click="() => {  openProductTemplateInIndesign({productTemplateId: template.templateId}); }"
                   class="w-1/3 px-1 leading-6 h-full text-center hover:bg-trader-blue hover:text-white cursor-pointer text-sm bg-indesign-dark text-indesign-light">
                <div class="font-bold text-[10px]">Id</div>
              </div>

            </div>

          </div>

        </div>
      </div>

      <div v-if="searchResult?.length > 6" @click="toggleMore" class="mt-2 flex justify-center bg-trader-dark-gray py-2 hover:bg-trader-hover-background hover:text-white cursor-pointer ">
        <div v-if="tabItemCount == 6" class="cursor-pointer" >Mehr anzeigen</div>
        <div v-else class="cursor-pointer">Weniger anzeigen</div>
      </div>


      <!-- @mouseleave="mouseLeave" -->
      <div class="w-full" v-if="hoveredTemplateInfo" @mouseover="mouseEnter(null)">
        <table class="mt-2 p-2  bg-primary w-full whitespace-nowrap">
          <tr>
            <td>Name:</td>
            <td class="pl-4 w-full">{{ hoveredTemplateInfo.templateName }}</td>
          </tr>
          <tr>
            <td>ID:</td>
            <td class="pl-4 w-full">{{ hoveredTemplateInfo.templateId }}</td>
          </tr>
          <tr>
            <td>Größe:</td>
            <td class="pl-4 w-full">{{ hoveredTemplateInfo.templateWidth }} x {{ hoveredTemplateInfo.templateHeight }}
            </td>
          </tr>
          <tr>
            <td>Erstellt:</td>
            <td class="pl-4 w-full">{{ formatDate(hoveredTemplateInfo.templateTimestamp) }}</td>
          </tr>
        </table>
      </div>

    </div>
    <div v-else>
      <p class="font-bold">Bitte einen Artikel auswählen.</p>
      Bitte wählen Sie eine Seite sowie einen Artikel im Akkordeon aus um passende Artikelvorlagen zu sehen.
    </div>
  </div>
</template>


<script>
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus";
import {mapActions, mapState} from "vuex";
import Modal from "@/components/Dialogs/Modal.vue";
import apolloClient from "@/apolloClient";
import Accordion from "@/components/Accordion/Accordion.vue";
import SignalBus from "@/application/SignalBus";
import showPreviewProduct from "@/components/Preview/showPreviewProduct.vue";

export default {
  name: "TemplateTap.vue",
  data() {
    return {
      selectedOption: "template",
      searchResult: [],
      hoveredTemplateInfo: null,
      leaveTimeout: null,
      isActive: false,
      isActiveAspect: false,
      groupId: 0,
      selectedOptionTemplate: "fitting",
      articleTemplateGroups: [],
      templateGroupId: 0,
      searchTerm: "",
      activeSearchTerm: "",
      pageStart: 0,
      page: 0,
    }
  },
  components: {
    Accordion,
    Modal
  },
  computed: {
    ...mapState('settings', ['tabItemCount']),
    ...mapState('user', ['userData']),
    ...mapState({
      pageId: state => state.pageId,
      productId: state => state.productId,
      placeholderSize: state => state.placeholderSize,
      productTemplateId: state => state.productTemplateId,
    }),
    templates: function () {
      let searchResults = []
      let i = this.tabItemCount * this.page;
      let counter = 0;
      while (i < this.searchResult.length && counter < this.tabItemCount) {

        searchResults.push(this.searchResult[i])
        i++;
        counter++;
      }
      return searchResults
    },
    pageCount: function () {
      if (this.searchResult == null || this.searchResult.length == 0) {
        return 1;
      }
      return Math.ceil(this.searchResult.length / this.tabItemCount);
    },
  },
  watch: {
    'placeholderSize.width': function (newWidth, oldWidth) {
      this.search();
    },
    'placeholderSize.height': function (newHeight, oldHeight) {
      this.search();
    },
    /*
    'productTemplateId': function (newGroupId, oldGroupId) {
      this.getTemplates();
    },

     */
  },
  methods: {
    ...mapActions('settings', ['setTabItemCount']),

    toggleMore() {
      if (this.tabItemCount == 6) {
        this.setTabItemCount(9);
      } else {
        this.setTabItemCount(6);
      }
    },
    ...mapActions('indesign', ['openProductTemplateInIndesign']),
    async getArticleTemplateGroups() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getArticleTemplateGroups {
          getArticleTemplateGroups {
            idArticleTemplateGroup
            name
          }
        }
      `,
        });

        this.articleTemplateGroups = response.data.getArticleTemplateGroups

      } catch (error) {
        console.error("Fehler beim Abrufen der articleTemplateGroups:", error);

      }
    },
    toggle(option) {
      if (option === 'all' && this.templateGroupId === 0) {
        eventBus.openConfirm({
          title: "Alle Vorlagen Aufrufen",
          message: "Möchten Sie wirklich alle Vorlagen Aufrufen?",
          onAccept: () => {
            this.selectedOptionTemplate = option;
            this.getTemplates();
          }
        });
      } else {
        this.selectedOptionTemplate = option;
        this.getTemplates();
      }
    },
    search() {
      this.activeSearchTerm = this.searchTerm;
      this.getTemplates();
    },
    showModal(templateId) {
      eventBus.openModal(showPreviewProduct, {
        pageId: this.pageId,
        productId: this.productId,
        templateId: templateId,
        center: true,
      }, {
        fullSize: true,
      });
    },
    onAssignTemplate: function (template) {
      SignalBus.emit("assign-template-to-product", template);
    },
    mouseEnter(template) {
      if (this.leaveTimeout !== null) {
        clearTimeout(this.leaveTimeout);
      }
      if (template !== null) {
        this.hoveredTemplateInfo = template
      }
    },
    mouseLeave() {
      this.leaveTimeout = setTimeout(() => {
        this.hoveredTemplateInfo = null;
      }, 1000)
    },
    formatDate(timestamp) {
      let date = new Date(timestamp * 1000);  // Konvertieren Sie den Unix-Zeitstempel in ein JavaScript Datum
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`; // Formatieren Sie das Datum als DD-MM-YYYY
    },

    nextPage() {
      if (this.page < this.pageCount - 1) {
        this.page += 1;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page -= 1;
      }
    },
    getTemplates: async function () {

      const templateData = {
        width: this.placeholderSize.width,
        height: this.placeholderSize.height,
        option: this.selectedOptionTemplate,
        templateGroupId: this.templateGroupId,
        searchTerm: this.activeSearchTerm
      }
      const query = gql`
        query GetTemplates($template: TemplateInput!) {
          templateSearch(template: $template){
            templateId
            templateName
            templateHeight
            templateWidth
            templateTimestamp
          }
        }
      `;
      try {

        const variables = {template: templateData};
        const {data} = await apolloClient.query({query, variables});

        this.searchResult = data.templateSearch;

      } catch (error) {
        console.error(error);
      }
    },
    clearSearch: function () {
      this.searchTerm = "";
      this.activeSearchTerm = "";
      this.getTemplates();
    },
  },
  mounted() {
    this.getTemplates();
    this.getArticleTemplateGroups();
  },
  created() {
    this.getArticleTemplateGroups();
  }
}
</script>